window.DOMHelpers = {
    show(el) { if (el) el.classList.remove('tasaciones-hidden'); },
    hide(el) { if (el) el.classList.add('tasaciones-hidden'); },
    isVisible(el) { return !el.classList.contains('tasaciones-hidden'); },
    setValue(el, val) { if (el) el.value = val != undefined ? val : ''; },
    setDisabled(el, val) { if (el) el.disabled = val; },
    setText(el, val) { if (el) el.textContent = val; },
    setHTML(el, val) { if (el) el.innerHTML = val; },

    setRadioValue(elems, value) {
        elems.forEach(radio => {
            radio.checked = radio.value === value;
        });
    },

    getRadioValue(elems) {
        for (const radio of elems) {
            if (radio.checked) {
                return radio.value;
            }
        }
        return null;
    },

    emptySelect(el, placeholder) {
        if (el) {
            el.innerHTML = '';
            const opt = document.createElement('option');
            opt.value = '';
            opt.textContent = placeholder;
            el.appendChild(opt);
        }
    },

    setSelectValue(select, value) {
        if (!select) return;
        for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].value == value) {
                select.selectedIndex = i;
                break;
            }
        }
    },

    normalize(str) {
        return (str || '')
            .toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/[\s\-]/g, '');
    },

    setSelectValueFlexible(select, value) {
        if (!select || !select.options) return;
        const target = this.normalize(value);
        for (let i = 0; i < select.options.length; i++) {
            if (this.normalize(select.options[i].value) === target ||
                this.normalize(select.options[i].textContent) === target) {
                select.selectedIndex = i;
                return;
            }
        }
    }
};